import React from 'react';
import { PictoProps } from '../index';

export const SearchFr = (props: PictoProps) => (
  <svg
    width={props.width || '22'}
    height={props.height || '26'}
    viewBox="0 0 22 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.3514 4.26027C14.3352 -0.10349 8.37641 -1.17085 4.07038 1.87733C-0.240557 4.93047 -1.29499 10.9573 1.71628 15.3211C4.40387 19.2182 9.44065 20.4742 13.5554 18.5331L18.1214 25.1457C18.6412 25.9003 19.6712 26.089 20.4215 25.5578C21.167 25.0266 21.3534 23.989 20.8286 23.2295L16.2626 16.6168C19.4799 13.3701 20.039 8.1524 17.3465 4.26027H17.3514ZM13.1091 14.9636C10.2891 16.9594 6.39505 16.2594 4.42349 13.4048C2.45194 10.5502 3.14345 6.60846 5.95856 4.61275C8.77857 2.61703 12.6726 3.31702 14.6442 6.16662C16.6157 9.02118 15.9242 12.963 13.1091 14.9587V14.9636Z"
      fill={props.fill || '#8C7215'}
    />
  </svg>
);
